import classnames from 'classnames';
import React from 'react';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IHeaderProps extends IBaseProps {
  title?: string | number;
  text?: string;
  align?: 'left' | 'center' | 'right';
}

const ALIGN_CLASSNAMES: Record<string, string> = {
  left: 'left',
  center: 'center',
  right: 'right',
};

const Header: React.FC<IHeaderProps> = (props) => {
  const { style, className, title, text, align = 'center' } = props;
  const alignClassName = ALIGN_CLASSNAMES[align] || '';

  return (
    <div
      style={style}
      className={classnames('dbg-calendar-table-header', className, alignClassName)}
    >
      <div className="dbg-calendar-table-header-num">{title}</div>
      <div className="dbg-calendar-table-header-text">{text}</div>
    </div>
  );
};

export default Header;
